module.exports = __webpack_public_path__ + "static/media/LK_Close.eb44d57b.svg";